import React from 'react';

const Stat = ({ label, value, unit, children }) => (
  <div className="px-5 py-4 min-w-0">
    <p className="m-0 text-[12px] text-lb-muted">{label}</p>
    <p className="m-0 mt-1 text-[22px] font-semibold text-lb-ink-strong leading-none tabular-nums">
      {value}
      {unit && <span className="text-[13px] font-medium text-lb-muted ml-1">{unit}</span>}
    </p>
    {children}
  </div>
);

/**
 * One-line portfolio summary from real building fields only. "N need
 * attention" filters the table to Fair and Poor buildings; each EPC mix
 * segment filters it to that class. `summary` comes from summarizePortfolio.
 */
export const BuildingsSummary = ({ summary, onShowNeedsAttention, onShowEpc }) => (
  <section
    className="card-base grid grid-cols-2 lg:grid-cols-[1fr_1fr_1fr_1.8fr] lg:divide-x divide-black/[0.06]"
    aria-label="Portfolio summary"
  >
    <Stat label="Buildings" value={summary.count}>
      {summary.needsAttention > 0 && (
        <button
          type="button"
          onClick={onShowNeedsAttention}
          className="mt-1.5 p-0 bg-transparent border-0 text-[12px] font-medium text-[#B87430] hover:underline focus-ring"
        >
          {summary.needsAttention} need{summary.needsAttention === 1 ? 's' : ''} attention →
        </button>
      )}
    </Stat>
    <Stat label="Floor area" value={summary.totalAreaM2.toLocaleString()} unit="m²" />
    <Stat label="Avg. performance" value={summary.avgPerformance ?? '—'} unit={summary.avgPerformance == null ? undefined : '%'} />
    <div className="px-5 py-4 col-span-2 lg:col-span-1 min-w-0">
      <p className="m-0 text-[12px] text-lb-muted" title="Estimated from performance scores until certified EPCs are connected">
        EPC mix <span className="text-lb-muted-soft">(est.)</span>
      </p>
      <div className="mt-2.5 flex h-2.5 rounded-full overflow-hidden gap-[2px]">
        {summary.epcMix.map((item) => (
          <button
            key={item.rating}
            type="button"
            onClick={() => onShowEpc(item.rating)}
            aria-label={`Show EPC ${item.rating} buildings (${item.count})`}
            title={`EPC ${item.rating}: ${item.count}`}
            className="h-full p-0 border-0 cursor-pointer hover:opacity-80 focus-ring"
            style={{ flex: item.count, background: item.color }}
          />
        ))}
      </div>
      <div className="mt-2 flex flex-wrap gap-x-3 gap-y-1" aria-hidden="true">
        {summary.epcMix.map((item) => (
          <span key={item.rating} className="inline-flex items-center gap-1 text-[11px] text-lb-muted">
            <span className="w-2 h-2 rounded-[2px]" style={{ background: item.color }} />
            {item.rating} <span className="text-lb-ink tabular-nums">{item.count}</span>
          </span>
        ))}
      </div>
    </div>
  </section>
);
